<template>
  <pt-insure-info-detail class="pt-insure-info-detail__page"></pt-insure-info-detail>
</template>

<script>
import PtInsureInfoDetail from 'cps/insurance-claims/pt-insure-info/pt-insure-info-detail/withData'
export default {
  name: 'pt-insure-info-detail__view',
  components: {
    'pt-insure-info-detail': PtInsureInfoDetail
  }
}
</script>
